<template>
  <div
    @click="click($event)"
    id="composer"
    class="composer"
    :data-recording-click-props='JSON.stringify({"composerVersion": $abtest("composer-starting-tab")})'
  >
    <Navigation
      ref="navigation"
      :modules="modules"
      :active="openedModuleId"
      @openModule="openModule"
      class="composer__nav"
    />

    <div ref="content" class="composer__content">
      <component
        :is="moduleComponent()"
        :selectionData="modules[openedModuleId]"
      ></component>
    </div>

    <div ref="footer" class="composer__footer">
      <!-- exception notices -->
      <slot v-if="$store.getters.getCountLoading === 0 && $store.getters.getSelectedItem.data !== null && $store.getters.getLvl1Loaded && $store.getters.getCurrentLevel === 1 && !selectedIsInList()">
        <FlashMessage
          ref="flashMessage"
          v-if="boxQty < 20"
          type="warning"
        >
          <p>Dieses Präsent ist aktuell in Ihrer gewünschten Menge nicht vorrätig. Bei nicht sofort lieferbaren Präsenten beträgt die Mindestbestellmenge 20 Stück. <router-link :to="cLink('/fertige')">Hier klicken</router-link>, um Präsente für geringere Stückzahlen oder schneller Lieferzeiten anzuzeigen.</p>
        </FlashMessage>

        <FlashMessage
          v-else
          ref="flashMessage"
          type="warning"
        >
          <p>Dieses Präsent ist für Ihre ausgewählte Menge nicht mehr auf Lager. Wenn Sie Präsente in größeren Mengen kaufen möchten, <router-link :to="cLink('/fertige')">klicken Sie hier</router-link>.</p>
        </FlashMessage>
      </slot>
      <!-- /exception notices -->

      <FlashMessage
        ref="flashMessage"
        v-if="errors.length > 0"
        :type="errors[0].type"
      >
        <p>{{ errors[0].message }}</p>
      </FlashMessage>

      <Summary
        ref="summary"
        class="composer__summary"
        @submit="submit()"
        :data="summary"
      />
    </div>

    <transition name="composer__overlay-transition">
      <div
        v-if="isOverlayVisible"
        @click="handleSummaryDetail()"
        class="composer__overlay"
      ></div>
    </transition>

    <transition name="composer__modal-backdrop-transition">
      <div
        v-if="activeModal.component"
        class="composer__overlay --is-backdrop"
      ></div>
    </transition>

    <transition name="composer__modal-transition">
      <!-- <component
        v-if="activeModal.component"
        :is="activeModal.component"
        class="composer__modal"
      ></component> -->

      <ModalPostcardMotives
        v-if="activeModal.component === 'ModalPostcardMotives'"
        :selectionData="modules.postcard.motive"
        class="composer__modal"
      />

      <ModalPostcardMessageHandwritten
        v-if="activeModal.component === 'ModalPostcardMessageHandwritten'"
        :selectionData="modules.postcard.message"
        class="composer__modal"
      />

      <ModalPostcardMessagePrinted
        v-if="activeModal.component === 'ModalPostcardMessagePrinted'"
        :selectionData="modules.postcard.message"
        class="composer__modal"
      />

      <ModalShippingIndividual
        v-if="activeModal.component === 'ModalShippingIndividual'"
        :selectionData="modules.shipping"
        class="composer__modal"
      />

      <ModalShippingBulk
        v-if="activeModal.component === 'ModalShippingBulk'"
        :selectionData="modules.shipping"
        class="composer__modal"
      />

      <ModalShippingCombined
        v-if="activeModal.component === 'ModalShippingCombined'"
        :selectionData="modules.shipping"
        class="composer__modal"
      />

      <ModalExternalContent
        v-if="activeModal.component === 'ModalExternalContent'"
        :params="activeModal.params"
        class="composer__modal"
      />
    </transition>
  </div>
</template>

<script>
import { logicMixin } from '@/mixins/LogicMixin';
import { UiMixin } from '@/mixins/UiMixin';
import { ValidationMixin } from '@/mixins/ValidationMixin';

import Navigation from '@/components/Composer/Navigation';
import ModulePresentLevel1 from '@/components/Composer/ModulePresentLevel1';
import ModulePresentLevel3 from '@/components/Composer/ModulePresentLevel3';
import ModulePostcard from '@/components/Composer/ModulePostcard';
import ModuleShipping from '@/components/Composer/ModuleShipping';
import Summary from '@/components/Composer/Summary';
import FlashMessage from '@/components/Composer/FlashMessage';

export default {
  name: 'Composer',
  mixins: [logicMixin, UiMixin, ValidationMixin],
  components: {
    Navigation,
    ModulePresentLevel1,
    ModulePresentLevel3,
    ModulePostcard,
    ModuleShipping,
    Summary,
    FlashMessage,

    // Modals
    ModalPostcardMotives: () => import('@/components/Composer/ModalPostcardMotives'),
    ModalPostcardMessageHandwritten: () => import('@/components/Composer/ModalPostcardMessageHandwritten'),
    ModalPostcardMessagePrinted: () => import('@/components/Composer/ModalPostcardMessagePrinted'),
    ModalShippingIndividual: () => import('@/components/Composer/ModalShippingIndividual'),
    ModalShippingBulk: () => import('@/components/Composer/ModalShippingBulk'),
    ModalShippingCombined: () => import('@/components/Composer/ModalShippingCombined'),
    ModalExternalContent: () => import('@/components/Composer/ModalExternalContent'),
  },
  props: {
    // Default opened module on init
    defaultModuleId: {
      type: String,
      default: 'present'
    },

    // environment: To define what's the context environment Composer is running in, by default is the Present Page `present`
    environment: {
      type: String,
      default: 'configurator'
    },

    // defaults: Whether Composer has or not default options / preselected options
    defaults: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      errors: [],
      openedModuleId: '',
      activeModal: {
        component: null,
        params: null
      },
      stockException: false,
      isOverlayVisible: false,
      firstClick: false,

      modules: {
        present: {
          conf: {
            id: 'present',
            name: {
              b2c: 'Inhalt',
              b2b: 'Inhalt'
            },
            icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><g transform="matrix(0.8333333333333334,0,0,0.8333333333333334,0,0)"><g><line x1="8.25" y1="3" x2="23.25" y2="3" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></line><line x1="8.25" y1="12" x2="23.25" y2="12" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></line><line x1="8.25" y1="21" x2="23.25" y2="21" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></line><rect x="0.75" y="0.75" width="4.5" height="4.5" rx="0.75" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></rect><rect x="0.75" y="9.75" width="4.5" height="4.5" rx="0.75" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></rect><rect x="0.75" y="18.75" width="4.5" height="4.5" rx="0.75" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></rect></g></g></svg>',
            component: ['ModulePresentLevel1', 'ModulePresentLevel3']
          },
          seen: true,
          isSet: true
        },

        postcard: {
          conf: {
            id: 'postcard',
            name: {
              b2c: 'Grußkarte',
              b2b: 'Grußkarte &<br>Branding'
            },
            icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><g transform="matrix(0.8333333333333334,0,0,0.8333333333333334,0,0)"><path style="fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;" d="M19.5,12.88V2.25A1.5,1.5,0,0,0,18,.75H6a1.5,1.5,0,0,0-1.5,1.5V12.88"></path><path style="fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;" d="M21.284,11.465a.75.75,0,0,1,1.216.587v9.7a1.5,1.5,0,0,1-1.5,1.5H3a1.5,1.5,0,0,1-1.5-1.5v-9.7a.75.75,0,0,1,1.216-.587l7.431,5.894a3,3,0,0,0,3.706,0Z"></path><line style="fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;" x1="15.808" y1="15.808" x2="18.75" y2="18.75"></line><line style="fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;" x1="8.192" y1="15.808" x2="5.25" y2="18.75"></line><polyline style="fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;" points="10.312 4.875 12 6 13.687 4.875"></polyline><line style="fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;" x1="12" y1="12.75" x2="12" y2="3.75"></line><polyline style="fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;" points="10.312 11.625 12 10.5 13.687 11.625"></polyline><polyline style="fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;" points="15.375 6.563 14.25 8.25 15.375 9.938"></polyline><line style="fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;" x1="7.5" y1="8.25" x2="16.5" y2="8.25"></line><polyline style="fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;" points="8.625 6.563 9.75 8.25 8.625 9.938"></polyline></g></svg>',
            component: 'ModulePostcard'
          },
          seen: false,
          isSet: false,
          main: {
            mode: null
          },
          motive: {
            mode: null,
            card: {
              id: null,
              src: null
            }
          },
          message: {
            mode: null,
            option: this.$store.getters.getUserGroupId === '14017' && this.boxQty > 1 ? 3 : 1,
            text: ''
          },
          addons: {
            backLogo: false,
            caseLogo: false
          }
        },

        shipping: {
          conf: {
            id: 'shipping',
            name: {
              b2c: 'Lieferung',
              b2b: 'Lieferung'
            },
            icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><g transform="matrix(0.8333333333333334,0,0,0.8333333333333334,0,0)"><g><path d="M9,18.37v-12H3.5A3,3,0,0,0,.75,9.53v7.79a1,1,0,0,0,.92,1.05H3.25" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></path><circle cx="5.5" cy="18.37" r="2.25" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></circle><circle cx="17.25" cy="18.37" r="2.25" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></circle><path d="M.75,10.87H5.13A.85.85,0,0,0,6,10V6.38" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></path><line x1="7.75" y1="18.37" x2="15" y2="18.37" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></line><line x1="0.75" y1="14.37" x2="3.21" y2="14.37" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></line><path d="M23.25,13.37H9V4.88a1.5,1.5,0,0,1,1.5-1.5H21.75a1.5,1.5,0,0,1,1.5,1.5Z" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></path><path d="M19.5,18.37h2.25a1.5,1.5,0,0,0,1.5-1.5v-3.5" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round;stroke-width: 1.5px"></path></g></g></svg>',
            component: 'ModuleShipping'
          },
          seen: false,
          isSet: false,
          main: {
            mode: this.defaults ? (this.$store.getters.getSelectedQty >= this.$store.getters.getOrderQtySize.xs.min ? 3 : 1) : null
          },

          // Mode 1 (Qty1, shipping at giftee)
          single: {
            option: 1,
            international: false,
            region: 'de',
            desiredShippingDate: ''
          },

          // Mode 3 (Einzelversand Direktversand an Beschenkte)
          individual: {
            international: false,
            regions: {
              de: 0,
              eu: 0,
              ch_uk: 0,
              other: 0
            }
          },

          // Mode 4 (Bulk shipping / Großversand)
          bulk: {
            multipleLocations: false,
            international: false,
            regions: {
              de: 0,
              other: 0
            },
            cardboardBoxWrap: false
          },

          // Mode 5 (Combined shipping)
          combined: {
            international: false,
            splitting: {
              national: {
                single: 0,
                bulk: 0
              },
              international: {
                single: {
                  de: 0,
                  eu: 0,
                  ch_uk: 0,
                  other: 0
                },
                bulk: {
                  de: 0,
                  other: 0
                }
              }
            }
          }
        }
      },

      // Summary defaults
      summary: {
        isSet: true,
        isExpanded: false,
        styleProps: {
          collapsedHeight: 0
        },
        submitText: 'Weiter'
      }
    };
  },

  methods: {
    moduleComponent () {
      if (this.openedModuleId === 'present') {
        if (this.$store.getters.getCurrentLevel === 1) {
          return this.modules[this.openedModuleId].conf.component[0];
        } else if (this.$store.getters.getCurrentLevel === 3) {
          return this.modules[this.openedModuleId].conf.component[1];
        }
      } else {
        return this.modules[this.openedModuleId].conf.component;
      }
    },

    openModule (moduleId) {
      // Check that the id of the module to open is not the same so it won't toggle
      if (moduleId !== this.openedModuleId) {
        this.openedModuleId = moduleId;

        // Set opened module as "seen" by settings seen to true
        this.modules[moduleId].seen = true;
      }
    },

    handleSummaryDetail () {
      if (this.summary.isExpanded === true) {
        this.isOverlayVisible = false;
        this.summary.isExpanded = false;
      } else {
        this.isOverlayVisible = true;
        this.summary.isExpanded = true;
      }
    },

    submit () {
      // Check for unopened / unset modules, so we open them before actually continue to the next step
      for (const module in this.modules) {
        if (!this.modules[module].seen && this.openedModuleId !== this.modules[module].conf.id) {
          this.openModule(module);

          return;
        }
      }

      // Run the validation
      this.errors = [];
      this.errors = this.doValidation();

      if (this.errors.length > 0) {
        this.$nextTick(() => {
          this.resizeUi();
        });

        if (this.errors[0].context && this.errors[0].context.module) {
          this.$nextTick(() => {
            this.openModule(this.errors[0].context.module);

            if (this.errors[0].context.anchor) {
              // Wait for the animation of expandModule to be completed before scrolling
              setTimeout(() => {
                this.scrollToComposerSection(this.errors[0].context.anchor);
              }, 1000);
            } else if (this.errors[0].context.modal) {
              this.$root.$emit('composerModal:open', this.errors[0].context.modal);
            }
          });
        }

        return;
      }

      // Save in session the referrer and take them to the confirmation page
      sessionStorage.setItem('confirmationPageReferrer', this.$router.history.current.path);

      this.$router.push({ path: this.cLink('/zusammenfassung') });
    },

    resizeUi () {
      const maxHeight = (() => {
        let threshold;
        let value;
        let gap = 0;

        if (this.environment === 'present') {
          threshold = 800;
        } else if (this.environment === 'configurator') {
          threshold = 920;

          // Substract 70 pixels from the calculation when it's mobile in the configurator, so the
          // Handler of the panel for mobile don't go hidden behind the header
          if (this.$store.getters.getMediaQueries.max.sm.matches) {
            gap = 70;
          }
        }

        if (window.innerHeight > threshold) {
          value = threshold - gap;
        } else {
          value = window.innerHeight - gap;
        }

        return value;
      })();

      const navigationHeight = this.$refs.navigation.$el.offsetHeight;
      const footerHeight = this.$refs.footer.offsetHeight;
      const spacer = this.$el.querySelector('.module__content') ? window.getComputedStyle(this.$el.querySelector('.module__content'), null).getPropertyValue('padding-left').replace(/[^0-9.]+/g, '') : 16;
      const contentHeight =
        maxHeight -
        navigationHeight -
        footerHeight -
        (spacer * 1);

      // Set CSS variables
      this.$el.style.setProperty('--content-height', `${contentHeight}px`);
      this.$el.style.setProperty('--footer-height', `${footerHeight}px`);
      this.$el.style.setProperty('--max-height', `${maxHeight}px`);
      this.$el.parentElement.style.setProperty('height', `${maxHeight - spacer}px`);
    },

    click (e) {
      if (!e.target.hasAttribute('data-ignore-scroll')) {
        if (this.$store.getters.isB2b && this.boxQty < 2) {
          this.$root.$emit('showSetupModal');
        }

        this.$emit('click');
      }
    }
  },

  watch: {
    stockException (newVal) {
      this.$nextTick(() => {
        this.resizeUi();
      });
    },

    boxQty (newVal, oldVal) {
      this.$nextTick(() => {
        this.resizeUi();
      });

      if (newVal !== oldVal) {
        // Set the shopping setup modal to false if the quantity has been changed beforehand
        sessionStorage.setItem('setupModal', false);
      }
    },

    // Listen for changes in the modules object and store the preferences in the session storage
    modules: {
      handler: function (newVal) {
        // Do some validation - set option automaticly consistent
        // Without card selected
        if (newVal.postcard.main.mode !== 1) {
          newVal.postcard.motive.mode = 0;
          newVal.postcard.motive.card.id = 0;
          newVal.postcard.motive.card.src = '';
          newVal.postcard.message.mode = 0;
          newVal.postcard.message.option = 0;
          newVal.postcard.message.text = '';
          newVal.postcard.addons.backLogo = false;
        }
        // own Card
        if (newVal.postcard.motive.mode === 2 && newVal.postcard.motive.mode !== JSON.parse(sessionStorage.getItem('composerItem')).postcard.motive.mode) {
          newVal.postcard.motive.card.id = 0;
          newVal.postcard.motive.card.src = '';
        }
        // Without Text
        if (newVal.postcard.message.mode > 2 && JSON.parse(sessionStorage.getItem('composerItem')).postcard.message.mode !== newVal.postcard.message.mode) {
          newVal.postcard.message.text = '';
          newVal.postcard.message.option = 0;
        }

        // different texts
        if (newVal.postcard.message.option > 1) {
          this.modules.postcard.message.text = '';
        }
        /* if (newVal.postcard.message.mode === 0 && newVal.postcard.message.option === 0 && newVal.postcard.main.mode === 1 && newVal.postcard.message.text === '') {
          newVal.postcard.message.mode = 3;
        } */
        sessionStorage.setItem('composerItem', JSON.stringify(newVal));
        this.$store.commit('setComposerModules', newVal);

        for (const module in newVal) {
          if (module.mode && module.mode.main !== null) {
            this.modules[module].isSet = true;
          }
        }

        if (this.errors.length > 0) {
          this.errors = [];

          this.$nextTick(() => {
            this.resizeUi();
          });
        }
      },
      deep: true
    },

    // Create and destroy an event listener for clicking anywhere in the page for closing the summary
    'summary.isExpanded': {
      handler: function (newVal) {
        if (newVal === true) {
          setTimeout(() => {
            document.body.addEventListener('click', this.handleSummaryDetail);
          }, 100);
        } else {
          document.body.removeEventListener('click', this.handleSummaryDetail);
        }
      }
    }
  },

  created () {
    // Expand the default module
    this.openModule(this.defaultModuleId);

    // Composer data structure and session storage
    const composerItem = sessionStorage.getItem('composerItem');

    if (composerItem !== null) {
      this.modules = JSON.parse(composerItem);
    }

    this.$store.commit('setComposerModules', this.modules);
    this.$store.commit('setComposerEnvironment', this.environment);

    this.$root.$on('switchedUserGroup', () => {
      this.modules.postcard.motive.mode = null;
      this.modules.postcard.main.mode = null;
      this.modules.postcard.motive.card.id = '';
      this.modules.postcard.motive.card.src = '';
      this.modules.postcard.message.mode = null;
      this.modules.postcard.message.option = this.$store.getters.getUserGroupId === '14017' && this.boxQty > 1 ? 3 : 1;
      this.modules.shipping.main.mode = null;
    });

    // Modal event listeners
    this.$root.$on('composerModal:open', (componentName, params) => {
      this.activeModal.component = componentName;

      if (params) {
        this.activeModal.params = params;
      }
    });

    this.$root.$on('composerModal:close', () => {
      this.activeModal.component = null;
      this.activeModal.params = null;
    });
  },

  mounted () {
    window.addEventListener('resize', this.resizeUi);

    this.$root.$on('changedQty', (value) => {
      const qtyValue = parseInt(value);
      if (qtyValue >= this.$store.getters.getOrderQtySize.sm.min) {
        if (this.modules.postcard.message.mode === 1) {
          if (this.modules.postcard.message.option && this.modules.postcard.message.option > 1) {
            this.modules.postcard.message.option = 1;
          } else {
          }
          this.modules.postcard.message.mode = 2;
        }
      } else {
        if (this.modules.postcard.message.mode === 2) {
          this.modules.postcard.message.mode = 1;
        }
      }
      if (qtyValue === 1) {
        this.modules.postcard.message.option = 1;
      } else if (qtyValue > 1) {
        this.modules.postcard.message.option = this.$store.getters.getUserGroupId === '14017' && this.boxQty > 1 ? 3 : 1;
      }

      if (qtyValue < this.$store.getters.getOrderQtySize.sm.min) {
        this.modules.postcard.addons.backLogo = false;
      }
      if (qtyValue < this.$store.getters.getOrderQtySize.md.min && this.modules.postcard.motive.mode === 2) {
        this.modules.postcard.motive.mode = null;
      }
      if (qtyValue < this.$store.getters.getOrderQtySize.md.min && this.modules.postcard.addons.caseLogo) {
        this.modules.postcard.addons.caseLogo = false;
      }
    });

    // Open "contents" tab if it's not open when adding level 3 products
    if (this.$store.getters.getCurrentLevel === 3) {
      this.$root.$on('addedLevel3Item', () => {
        if (this.openedModuleId !== 'present') {
          this.openModule('present');
        }
      });
    }

    // Detect if #edit hash is present in the URL in order to open the module
    if (window.location.hash) {
      if (window.location.hash === '#postcard') {
        this.openModule('postcard');
      } else if (window.location.hash === '#shipping') {
        this.openModule('shipping');
      } else {
        this.openModule('postcard');
      }
    }

    this.resizeUi();
  },

  destroyed () {
    window.removeEventListener('resize', this.resizeUi);
  }
};
</script>

<style lang="scss" scoped>
/**
 * Composer
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Composer main (wrapper) component, v2
 * @since 2022-04-06
**/

$component: 'composer';

.#{$component} {
  // Public vars
  --min-height: 400px;
  --max-height: 800px;
  --content-height: 200px;
  --footer-height: 0px;

  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: var(--min-height);
  max-height: var(--max-height);
  z-index: 0;
  overflow: hidden;
  border-radius: $border-radius-lg;
  background-color: $white;
  box-shadow: 5px 5px 30px rgba($ink, 0.4);
  transition: height, max-height linear 0.5s;

  &__content {
    position: relative;
    flex-grow: 1;
    z-index: 0;
    height: auto;
    max-height: 100%;
    overflow: hidden;
    margin-bottom: var(--footer-height);

    &:before,
    &:after {
      content: '';
      display: block;
      position: absolute;
      z-index: 1;
      width: 100%;
      @include rfs(map-get($spacers, 3), height);
      pointer-events: none;
    }

    &:before {
      top: 0;
      @include linear-gradient(180deg, $white, transparent);
    }

    &:after {
      bottom: 0;
      @include rfs(map-get($spacers, 4), height);
      @include linear-gradient(0, $white, transparent);
    }
  }

  &__footer {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;

    ::v-deep {
      .flash-message {
        margin-bottom: 0;
        @include padding(map-get($spacers, 2) map-get($spacers, 4));
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        @include font-size($font-size-sm);
      }
    }
  }

  // Overlay
  &__overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    border-radius: $border-radius-lg;
    background-color: $white;
    opacity: 0.6;
    transition: all 0.3s ease;

    &.--is-backdrop {
      z-index: 8;
      background: $ink;
    }
  }

  // Modal
  &__modal {
    transition: all 0.4s ease;
    transform: translateY(0);
  }

  @at-root {
    &__overlay-transition {
      &-enter-active, &-leave-active {
        opacity: 0.6;
      }

      &-enter, &-leave-to {
        opacity: 0;
      }
    }

    &__modal-backdrop-transition {
      &-enter-active, &-leave-active {
        opacity: 0.6;
      }
      &-enter, &-leave-to {
        opacity: 0;
      }
    }

    &__modal-transition {
      &-enter-active, &-leave-active {
        opacity: 1;
      }
      &-enter, &-leave-to {
        opacity: 1;
        transform: translateY(100%);
      }
    }
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
  }
}
</style>
